import { Pipe, PipeTransform } from '@angular/core';

/** Montant FCFA : « 25 000 » ou, avec unite=true, « 25 000 FCFA » */
@Pipe({ name: 'fcfa' })
export class FcfaPipe implements PipeTransform {
  transform(v: number | null | undefined, unite = false, signe = false): string {
    if (v == null || isNaN(+v)) return '—';
    const n = Math.round(+v);
    const txt = Math.abs(n).toLocaleString('fr-FR').replace(/ | /g, ' ');
    const s = n < 0 ? '−' : (signe && n > 0 ? '+' : '');
    return `${s}${txt}${unite ? ' FCFA' : ''}`;
  }
}

const MOIS_COURTS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

export function parseDateLocale(v: string | Date | null | undefined): Date | null {
  if (!v) return null;
  if (v instanceof Date) return v;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

/** Dates en français : court (24/09/2026), long (24 sept. 2026), jour (jeudi 24 sept.), relatif (aujourd'hui, hier…) */
@Pipe({ name: 'dateFr' })
export class DateFrPipe implements PipeTransform {
  transform(v: string | Date | null | undefined, format: 'court' | 'long' | 'jour' | 'relatif' | 'heure' = 'long'): string {
    const d = parseDateLocale(v);
    if (!d) return '—';
    const p = (n: number) => String(n).padStart(2, '0');
    switch (format) {
      case 'court': return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
      case 'heure': return `${p(d.getHours())}:${p(d.getMinutes())}`;
      case 'jour': {
        const j = JOURS[d.getDay()];
        return `${j.charAt(0).toUpperCase()}${j.slice(1)} ${d.getDate()} ${MOIS_COURTS[d.getMonth()]}${d.getFullYear() !== new Date().getFullYear() ? ' ' + d.getFullYear() : ''}`;
      }
      case 'relatif': {
        const auj = new Date(); auj.setHours(0, 0, 0, 0);
        const jour = new Date(d); jour.setHours(0, 0, 0, 0);
        const diff = Math.round((auj.getTime() - jour.getTime()) / 86400000);
        if (diff === 0) return 'aujourd\'hui';
        if (diff === 1) return 'hier';
        if (diff === -1) return 'demain';
        if (diff > 1 && diff < 7) return `il y a ${diff} jours`;
        if (diff < -1 && diff > -7) return `dans ${-diff} jours`;
        return `${d.getDate()} ${MOIS_COURTS[d.getMonth()]}${d.getFullYear() !== new Date().getFullYear() ? ' ' + d.getFullYear() : ''}`;
      }
      default: return `${d.getDate()} ${MOIS_COURTS[d.getMonth()]} ${d.getFullYear()}`;
    }
  }
}

/** Téléphone masqué pour les journaux : +221 77 ••• 12 34 */
@Pipe({ name: 'telMasque' })
export class TelMasquePipe implements PipeTransform {
  transform(v: string | null | undefined): string {
    const d = (v || '').replace(/\D/g, '');
    if (d.length < 6) return v || '';
    return `+${d.slice(0, d.length - 7)} ${d.slice(-7, -5)} ••• ${d.slice(-4, -2)} ${d.slice(-2)}`;
  }
}

/** Libellé lisible d'une valeur d'énumération (EN_COURS → En cours) avec table facultative */
@Pipe({ name: 'enumLabel' })
export class EnumLabelPipe implements PipeTransform {
  transform(v: string | null | undefined, table?: { [k: string]: string }): string {
    if (!v) return '';
    if (table && table[v]) return table[v];
    const s = v.replace(/_/g, ' ').toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
}

/** Taille de fichier lisible */
@Pipe({ name: 'taille' })
export class TaillePipe implements PipeTransform {
  transform(o: number | null | undefined): string {
    if (!o) return '';
    if (o < 1024) return `${o} o`;
    if (o < 1024 * 1024) return `${Math.round(o / 1024)} Ko`;
    return `${(o / 1024 / 1024).toFixed(1).replace('.', ',')} Mo`;
  }
}
